import React from 'react';
import { Ellipsis } from '@gravity-ui/icons';
import { Button, DropdownMenu, Icon } from '@gravity-ui/uikit';
import i18n from '../../i18n';
export const RemoveButton = ({ name, onDrop }) => {
    const items = React.useMemo(() => [{ text: i18n('label_delete'), action: onDrop, theme: 'danger' }], [onDrop]);
    const switcher = React.useMemo(() => (React.createElement(Button, { view: "flat", qa: `${name}-drop-item` },
        React.createElement(Icon, { data: Ellipsis, size: 16 }))), []);
    return React.createElement(DropdownMenu, { switcher: switcher, items: items });
};
